import React from 'react';

import { RHP } from 'providers';
import { useForm } from 'components/form';

import * as Form from 'components/form';
import * as Page from 'components/page';

import * as Styled from './styles';

export function StartupStep5(props) {
    const { vars, putStartupRankingApplication } = props.useRankingStartup;
    const { application } = vars;

    // Initialize a new form handler
    const form = useForm({
        growUpInterest:
            application.growUpInterest === true
                ? 'true'
                : application.growUpInterest === false
                  ? 'false'
                  : ''
    });

    // Check for previous step conclusion
    if (!vars.application.steps || vars.application.steps.step4 !== true) {
        RHP.replace('/ranking/latam/startup/');
        return null;
    }

    // Handle form submitions
    const onSubmit = values => {
        const payload = {
            ...application,
            growUpInterest: values.growUpInterest === 'true'
        };

        if (!payload.steps) payload.steps = {};
        payload.steps.step5 = true;

        return putStartupRankingApplication(payload)
            .then(() => RHP.push('/ranking/latam/startup/step6'))
            .catch(() => form.submited());
    };

    const fields = {
        growUpInterest: {
            error: form.errors.growUpInterest,
            label: props.t('StartupStep5.growUpInterest'),
            name: 'growUpInterest',
            type: 'YesNo',
            value: form.values.growUpInterest,
            onChange: form.handleChange
        }
    };

    const evSubmit = ev => form.handleSubmit(ev, onSubmit);
    return (
        <Page.Page
            name="StartupStep5"
            back="/ranking/latam/startup"
            customBackText={props.t('glossary:backToRanking')}
        >
            <Styled.StartupStep5>
                <Page.Title>{props.t('StartupStep5.title')}</Page.Title>
                <Page.Descr>{props.t('StartupStep5.descr')}</Page.Descr>

                <Form.Form name="StartupStep5Form" onSubmit={evSubmit}>
                    <Form.Field {...fields.growUpInterest} />
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Page.Buttn style={{ width: '25%' }} to="/ranking/latam/startup/step4">
                            <span className="icon far fa-long-arrow-left" aria-hidden="true" />
                            <span className="text" style={{ margin: '0 0 0 auto' }}>
                                {props.t('glossary:back')}
                            </span>
                        </Page.Buttn>
                        <div style={{ width: '80%' }}>
                            <Form.Submt
                                paddingTop="10rem"
                                {...form}
                                text={props.t('glossary:save')}
                            />
                        </div>
                    </div>
                </Form.Form>
            </Styled.StartupStep5>
        </Page.Page>
    );
}
